import { PerspectivesConditionalFormatting } from './PerspectivesConditionalFormatting';
import { FormattingTabProps } from '../types';
import { TabLayout } from '../TabLayout';

export const FormattingTab = ({
  conditionalFormatting,
  tabDescription,
  i18nLocale,
}: FormattingTabProps) => {
  const sections = [
    {
      key: 'formatting',
      ...tabDescription,
      content: (
        <PerspectivesConditionalFormatting
          {...conditionalFormatting}
          i18nLocale={i18nLocale}
        />
      ),
    },
  ];

  return <TabLayout sections={sections} />;
};
